import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManualPaymentService } from 'src/app/services/core/manual-payment/manual-payment.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-bulk-manual-payment-modal',
  templateUrl: './bulk-manual-payment-modal.component.html'
})
export class BulkManualPaymentModalComponent implements OnInit {
  @Input() billingIds: string[] = [];
  // emits the bulk result ({ batchId, createdPayments, skippedPayments }), the parent shows it
  @Output() closeModal = new EventEmitter<any>();
  manualPaymentForm!: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private manualPaymentService: ManualPaymentService
  ) { }

  get form() {
    return this.manualPaymentForm.controls;
  }

  ngOnInit() {
    this.manualPaymentForm = this.fb.group({
      transaction_no: ['', Validators.required],
      paymentType: ['', Validators.required]
    });
  }

  onSave() {
    this.submitted = true;
    if (this.manualPaymentForm.invalid) {
      return;
    }
    this.manualPaymentService.createBulk({ ...this.manualPaymentForm.value, billings: this.billingIds }).subscribe({
      next: (data: any) => this.closeModal.emit(data),
      error: (error: any) => sweetAlert('Error', error, 'error', 'OK')
    });
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
